export { default } from './pins-svg';
